export default "/images/e28f31722c582ccb8ce175dffbd018cb.png";